import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import { media } from 'utils/style';

const ResponsiveHide = styled.div`
  display: ${(props) => (!!props.hideNormal ? 'none' : 'initial')};
  ${media.lessThan('small')`
  display: ${(props) => (!!props.hideMobile ? 'none' : 'initial')};
  `}
`;

ResponsiveHide.propTypes = {
  hideNormal: PropTypes.bool,
  hideMobile: PropTypes.bool,
};

export default ResponsiveHide;
